import { PardotList } from './PardotList';
import { usePeriscopeActions } from '@hooks';
import { PeriscopePardotList, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';

export interface PardotListRowProps {
	record: PeriscopePardotList;
	parentIndex: number;
}

export const PardotListRow: React.FC<PardotListRowProps> = ({ record, parentIndex }) => {
	const { openPeriscope } = usePeriscopeActions();

	const handleListClick = useCallback(
		(item: PeriscopePardotList) => {
			const { displayName, sonarObjectId } = item;

			openPeriscope({
				id: sonarObjectId,
				name: displayName,
				openedFromIndex: parentIndex,
				type: SonarObjectType.PardotList
			});
		},
		[ openPeriscope, parentIndex ]
	);

	return <PardotList
		entity={ record }
		key={ record.sonarObjectId }
		onListClick={ handleListClick } />;
};
